import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { editionOf, editionPath } from 'utils/visualApps';

// `subscription` arrives as 0, '0' or a plan id; only a non-zero value is a paid plan.
export const hasSubscription = (user) => Number(user?.subscription || 0) !== 0;

// Opening a trip/article: free content opens, premium content needs a subscriber,
// a guest is asked to sign in (render <Login open={loginOpen} onClose={closeLogin} />).
export const useContentAccess = () => {
  const { userDetails } = useSelector((store) => store.commonData);
  const navigate = useNavigate();
  const [loginOpen, setLoginOpen] = useState(false);

  const open = useCallback((item, path) => {
    if (!item.isPremium) return navigate(path);
    if (!userDetails) return setLoginOpen(true);
    navigate(hasSubscription(userDetails) ? path : '/subscribe');
  }, [userDetails, navigate]);

  const openTrip = useCallback((item) => open(item, '/trip/' + item.tripId), [open]);
  const openArticle = useCallback((item) => open(item, `/article/${item.tripId}/${item.articleId}/`), [open]);
  // a special edition opens its own page when this app has one, otherwise the trip
  const openEdition = useCallback((item) => {
    const key = editionOf(item);
    open(item, key ? editionPath(key) : '/trip/' + item.tripId);
  }, [open]);
  const closeLogin = useCallback(() => setLoginOpen(false), []);

  return { openTrip, openArticle, openEdition, loginOpen, closeLogin };
};
